function videoEmbedPlayButton () {
    document.querySelectorAll('button').forEach(function(button) {
        button.addEventListener('click', function() {
            let overlay = button.closest('.iframe-wrapper__overlay');
            if (overlay) {
                overlay.style.display = 'none';
                let iframe = overlay.nextElementSibling.querySelector('iframe');
                if (iframe) {
                    let src = iframe.getAttribute('src');
					if (src.indexOf('autoplay=1') === -1) {
						if (src.indexOf('?') > -1) {
							src += '&autoplay=1';
						} else {
							src += '?autoplay=1';
						}
						iframe.setAttribute('src', src);
					}
                }
            }
        });
    });
}

export default videoEmbedPlayButton;